import React from 'react';
import { AppBar, Toolbar, Box, IconButton, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import HelpButton from './HelpButton';

const Header = () => {
  // Dummy logout handler
  const handleLogout = () => {
    // Implement actual logout logic here
    localStorage.removeItem('authToken');
    window.location.href = '/signin';
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: '#fff',
        color: '#492099',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: '0 2px 16px rgba(92,59,139,0.08)', // Match NewNote/SimpleEditor shadow
        border: 'none',
        height: { xs: 48, sm: 56 }, // Reduce height on mobile
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: { xs: 48, sm: 56 }, height: { xs: 48, sm: 56 }, paddingTop: 0, paddingBottom: 0 }}>
        {/* Left: Logo and NoteRefinery */}
        <Box display="flex" alignItems="center" gap={2}>
          <a href="/app" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src="/logo2-removebg-preview.png" alt="Logo" style={{ width: 42, height: 42 }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#492099', letterSpacing: 1, ml: 1 }}>
              NoteRefinery
            </Typography>
          </a>
        </Box>
        {/* Right: Help and Logout Icons */}
        <Box display="flex" alignItems="center" gap={1}>
          <HelpButton headerMode />
          {/* Survey Icon Button */}
          <IconButton
            onClick={() => window.location.href = '/survey'}
            title="Feedback survey"
            sx={{ color: '#492099' }}
          >
            <AssignmentOutlinedIcon style={{ width: 32, height: 32 }} />
          </IconButton>
          <IconButton onClick={handleLogout} title="Log Out" sx={{ color: '#492099' }}>
            <LogoutIcon style={{ width: 32, height: 32 }} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
